import type {
  ProductsQueryParams,
  Product,
} from '@/entities/products/model/types/product';

export const useProducts = async (params: ProductsQueryParams, key: string = 'products') => {
  const page = ref(1);
  const { $productsService } = useNuxtApp();

  const getProducts = async () => {
    const { data } = await $productsService.getAllProducts({ page: page.value, ...params });
    return data;
  };

  const { data } = await useAsyncData(`products-${key}`, () => getProducts(), {
    watch: [page],
  });

  return {
    products: (data.value?.results || []) as Product[],
    total: (data.value?.count || 0) as number,
    getProducts,
    page,
  };
};